import React, { Fragment, useState, useEffect, useContext } from "react";
import { Redirect } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import {
  AddShoppingCart,
  CloudUpload,
  PhotoCamera,
  AttachMoney,
  Delete,
  Create,
  Visibility,
  VisibilityOff,
} from "@material-ui/icons/";
import Divider from "@material-ui/core/Divider";
import CircularProgress from "@material-ui/core/CircularProgress";
import { UrlServicesContext } from "../components/UrlServicesContext";
import axios from "axios";
import Alert from "@material-ui/lab/Alert";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

import ViewNewProduct from "../views/dialog/ViewNewProduct";
import ViewProduct from "../views/dialog/ViewProduct";
import DeleteProduct from "../views/dialog/DeleteProduct";
import UpdateProduct from "../views/dialog/UpdateProduct";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: "#000",
  },
  dividerBottom: {
    marginBottom: "2%",
  },
  input: {
    display: "none",
  },
  upload: {
    margin: "2% 0 2% 0",
  },
  product: {
    objectFit: "cover",
    height: "200px",
  },
  dividerBottomColor: {
    width: "80%",
    borderColor: "#F7F00B",
    marginBottom: "2%",
  },
  textBotom: {
    padding: "1%",
    fontFamily: '"Yanone Kaffeesatz", Sans-serif',
    letterSpacing: "1.5px",
    fontWeight: "600",
    textDecoration: "none",
    color: "#000",
  },
}));

export default function Productos() {
  const classes = useStyles();
  const [alert] = useState({
    loggedIn: localStorage.getItem("token") === null ? false : true,
  });

  const [loader, setLoader] = useState(true);
  const [openNewProduct, setOpenNewProduct] = useState(false);
  const [openViewProduct, setOpenViewProduct] = useState(false);
  const [product, setProduct] = useState([]);
  const [error, setError] = useState(false);
  const [countProduct, setCountProduct] = useState(0);
  const [noProduct, setNoProduct] = useState(false);
  const [idProduct, setIdProduct] = useState("");
  const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
  const [openUpdateProduct, setOpenUpdateProduct] = useState(false);

  const { urlServices, urlImgServicesProductos } = useContext(
    UrlServicesContext
  );

  const refresh = (pro) => {
    if (pro) {
      const data = new FormData();
      data.append("id", localStorage.getItem("user_id"));

      axios
        .post(urlServices + "routes.php?servicio=consultarProductos", data)
        .then(
          (response) => {
            if (response.data.code === 0) {
              setProduct(response.data.result);
              setCountProduct(response.data.count);
              setLoader(false);
              setNoProduct(false);
            } else {
              setLoader(false);
              setNoProduct(true);
            }
          },
          (error) => {
            setLoader(false);
            setError(true);
          }
        );
    }
  };

  useEffect(() => {
    const data = new FormData();
    data.append("id", localStorage.getItem("user_id"));

    const consultar = async () => {
      await axios
        .post(urlServices + "routes.php?servicio=consultarProductos", data)
        .then(
          (response) => {
            if (response.data.code === 0) {
              console.log(response);
              setCountProduct(response.data.count);
              setProduct(response.data.result);
              setLoader(false);
            } else {
              setLoader(false);
              setNoProduct(true);
            }
          },
          (error) => {
            setLoader(false);
            setError(true);
          }
        );
    };

    consultar();
  }, [urlServices]);

  const handleCloseViewNewProduct = () => {
    setOpenNewProduct(false);
  };

  const handleCloseDeleteProduct = () => {
    setOpenDeleteProduct(false);
  };

  const handleCloseUpdateProduct = () => {
    setOpenUpdateProduct(false);
  };

  const handleCloseViewProduct = () => {
    setOpenViewProduct(false);
  };

  const handleViewProduct = (id) => () => {
    setOpenViewProduct(true);
    setIdProduct(id);
  };

  const handleDeleteProduct = (id) => () => {
    setOpenDeleteProduct(true);
    setIdProduct(id);
  };

  const handleUpdateProduct = (id) => () => {
    setOpenUpdateProduct(true);
    setIdProduct(id);
  };

  const listItems = product.map((index, key) => (
    <Grid key={key} item xs={6} md={3}>
      <Card className={classes.root}>
        <CardActionArea>
          <CardMedia
            key={key}
            component="img"
            alt="productos"
            image={urlImgServicesProductos + index.imagen}
            className={classes.product}
            onClick={handleViewProduct(index.id)}
          />
          {index.estatus === "1" ? (
            <Fragment>
              <Visibility
                style={{
                  color: "green",
                  position: "absolute",
                  top: "5px",
                  left: "5px",
                  background: "rgba(255,255,255,0.8)",
                  padding: "1% 3%",
                  fontSize: "21",
                }}
                onClick={handleViewProduct(index.id)}
              />
              <Typography
                align="left"
                variant="subtitle2"
                style={{
                  color: "green",
                  position: "absolute",
                  top: "5px",
                  marginLeft: "17%",
                  background: "rgba(255,255,255,0.8)",
                  padding: "1% 3%",
                  fontWeight: "bold",
                }}
                onClick={handleViewProduct(index.id)}
              >
                Activo
              </Typography>
            </Fragment>
          ) : (
            <Fragment>
              <VisibilityOff
                style={{
                  color: "red",
                  position: "absolute",
                  top: "5px",
                  left: "5px",
                  background: "rgba(255,255,255,0.8)",
                  padding: "1% 3%",
                  fontSize: "21",
                }}
                onClick={handleViewProduct(index.id)}
              />
              <Typography
                align="left"
                variant="subtitle2"
                style={{
                  color: "red",
                  position: "absolute",
                  top: "5px",
                  marginLeft: "17%",
                  background: "rgba(255,255,255,0.8)",
                  padding: "1% 3%",
                  fontWeight: "bold",
                }}
                onClick={handleViewProduct(index.id)}
              >
                Inactivo
              </Typography>
            </Fragment>
          )}
        </CardActionArea>
        <CardActions>
          <Grid container spacing={3}>
            <Grid key={key} item xs={7} md={7}>
              {" "}
              <div style={{ fontSize: "18px", margin: "10px", color: "#333" }}>
                {" "}
                <AttachMoney style={{ fontSize: "18px", color: "#333" }} />
                {index.precio}
              </div>
            </Grid>
            <Grid key={key} item xs={2} md={2}>
              {" "}
              <center>
                {" "}
                <Tooltip title="Modificar">
                  <IconButton
                    aria-label="modificar"
                    onClick={handleUpdateProduct(index.id)}
                  >
                    <Create />
                  </IconButton>
                </Tooltip>
              </center>
            </Grid>
            <Grid key={key} item xs={2} md={2}>
              <center>
                <Tooltip title="Eliminar">
                  <IconButton
                    aria-label="eliminar"
                    onClick={handleDeleteProduct(index.id)}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>
              </center>
            </Grid>
          </Grid>

          {/*<Button size="small" color="primary">
            Learn More
          </Button>
  */}
        </CardActions>
      </Card>
    </Grid>
  ));

  if (!alert.loggedIn) {
    return <Redirect to="/" />;
  }

  if (loader) {
    return (
      <Fragment>
        <CircularProgress />
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <Typography
          align="left"
          variant="subtitle1"
          className={classes.textBotom}
        >
          <AddShoppingCart className={classes.icon} /> Productos
        </Typography>
        <Divider className={classes.dividerBottom} />
        {error ? <Alert severity="error">Error en la consulta!</Alert> : ""}
        <Grid container spacing={2} style={{ marginBottom: "10%" }}>
          <Grid item xs={12} sm={12} className={classes.upload}>
            <center>
              {countProduct < "10" ? (
                <Button
                  variant="contained"
                  color="default"
                  className={classes.textBotom}
                  startIcon={<CloudUpload />}
                  onClick={() => setOpenNewProduct(true)}
                >
                  Subir producto
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="default"
                  className={classes.button}
                  startIcon={<CloudUpload />}
                  disabled={true}
                >
                  Subir producto
                </Button>
              )}
            </center>
          </Grid>

          <Grid item xs={12} sm={12}>
            <center>
              <Divider
                variant="middle"
                light={true}
                className={classes.dividerBottomColor}
              />
            </center>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              align="left"
              variant="subtitle2"
              className={classes.textBotom}
            >
              Solo 10 productos permitidos.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              align="right"
              variant="subtitle2"
              style={{ color: "#000" }}
            >
              <PhotoCamera style={{ fontSize: "18px" }} /> {countProduct}
            </Typography>
          </Grid>

          {noProduct ? (
            <Grid item xs={12} sm={12} style={{ margin: "5% 0 15% 0" }}>
              <center>
                <img
                  src=".../../images/undraw_photos_1nui.png"
                  alt="noImage"
                  width="200"
                />
                <Typography
                  align="center"
                  variant="subtitle2"
                  color="textSecondary"
                >
                  NO HAY PRODUCTOS CARGADOS
                </Typography>
              </center>
            </Grid>
          ) : (
            listItems
          )}
        </Grid>

        {openNewProduct ? (
          <ViewNewProduct
            open={openNewProduct}
            exit={handleCloseViewNewProduct}
            callBackRefresh={refresh}
          />
        ) : (
          ""
        )}

        {openViewProduct ? (
          <ViewProduct
            open={openViewProduct}
            exit={handleCloseViewProduct}
            callBackRefresh={refresh}
            id={idProduct}
          />
        ) : (
          ""
        )}

        {openDeleteProduct ? (
          <DeleteProduct
            open={openDeleteProduct}
            exit={handleCloseDeleteProduct}
            callBackRefresh={refresh}
            id={idProduct}
          />
        ) : (
          ""
        )}

        {openUpdateProduct ? (
          <UpdateProduct
            open={openUpdateProduct}
            exit={handleCloseUpdateProduct}
            callBackRefresh={refresh}
            id={idProduct}
          />
        ) : (
          ""
        )}
      </Fragment>
    );
  }
}
